import { ITitleClient } from './BrowserTitleClient';

export interface ITitleService {
    applyTitle(): void;
    changeTitle(title: string): void;
    createSubTitleService(title: string): ITitleService;
}

export class TitleService implements ITitleService {
    private currentTitle: string = '';

    constructor(
        private titleClient: ITitleClient,
        private baseTitleParts: string[] = [],
        private separator: string = ' | ',
    ) {}

    createSubTitleService(title: string): ITitleService {
        return new TitleService(this.titleClient, [...this.baseTitleParts, title], this.separator);
    }

    private getFormattedTitle(): string {
        const parts = [...this.baseTitleParts, this.currentTitle];

        return parts.filter(Boolean).reverse().join(this.separator);
    }

    changeTitle(title: string): void {
        this.currentTitle = title;
        this.applyTitle();
    }

    applyTitle(): void {
        this.titleClient.setTitle(this.getFormattedTitle());
    }
}
